import React, { useState } from 'react';
import ActionPacks from './ActionPacks';
import Integrations from './Integrations';
import styles from './Settings.module.css';

const Settings = () => {
  const [activeTab, setActiveTab] = useState('actionPacks');

  return (
    <div className={styles.container}>
      <div className={styles.header}>
        <h1>Settings</h1>
        <p>Manage system configurations and integrations</p>
      </div>
      
      <div className={styles.tabs}>
        <button
          className={`${styles.tab} ${activeTab === 'actionPacks' ? styles.active : ''}`}
          onClick={() => setActiveTab('actionPacks')}
        >
          Action Packs
        </button>
        <button
          className={`${styles.tab} ${activeTab === 'integrations' ? styles.active : ''}`}
          onClick={() => setActiveTab('integrations')}
        >
          Integrations
        </button>
      </div>

      <div className={styles.content}>
        {activeTab === 'actionPacks' && <ActionPacks />}
        {activeTab === 'integrations' && <Integrations />}
      </div>
    </div>
  );
};

export default Settings;